// extracted by mini-css-extract-plugin
export default {"flex":"lW","imgwrap":"mW","image":"nW","textinfo":"oW","producttitle":"pW","bolder":"qW","block":"rW","info":"sW","moredetails":"tW","whitebox":"uW","old_price":"vW","discount":"wW"};
    if(module.hot) {
      // 1730991511444
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  